import ShopgateConnectTrustedLocaleEnUs from '@shopgate/connect-trusted/frontend/locale/en-US.json';
import ShopgateConnectTrustedLocaleDeDe from '@shopgate/connect-trusted/frontend/locale/de-DE.json';
import ShopgateConnectTrustedLocaleFrFr from '@shopgate/connect-trusted/frontend/locale/fr-FR.json';
import ShopgateConnectTrustedLocaleNlNl from '@shopgate/connect-trusted/frontend/locale/nl-NL.json';
import ShopgateConnectTrustedLocaleEsEs from '@shopgate/connect-trusted/frontend/locale/es-ES.json';
import ShopgateConnectTrustedLocaleItIt from '@shopgate/connect-trusted/frontend/locale/it-IT.json';
import ShopgateConnectTrustedLocalePtPt from '@shopgate/connect-trusted/frontend/locale/pt-PT.json';

export default {
  '@shopgate/connect-trusted/locale/en-US': ShopgateConnectTrustedLocaleEnUs,
  '@shopgate/connect-trusted/locale/de-DE': ShopgateConnectTrustedLocaleDeDe,
  '@shopgate/connect-trusted/locale/fr-FR': ShopgateConnectTrustedLocaleFrFr,
  '@shopgate/connect-trusted/locale/nl-NL': ShopgateConnectTrustedLocaleNlNl,
  '@shopgate/connect-trusted/locale/es-ES': ShopgateConnectTrustedLocaleEsEs,
  '@shopgate/connect-trusted/locale/it-IT': ShopgateConnectTrustedLocaleItIt,
  '@shopgate/connect-trusted/locale/pt-PT': ShopgateConnectTrustedLocalePtPt,
};
